class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this._hoverLeaveTimeout = null;
    this._mouseInside = false;
    this._boundMouseEnter = this._onMouseEnter.bind(this);
    this._boundMouseLeave = this._onMouseLeave.bind(this);
    this.addEventListener('mouseenter', this._boundMouseEnter);
    this.addEventListener('mouseleave', this._boundMouseLeave);
  }

  _onMouseEnter() {
    this._mouseInside = true;
    if (this._hoverLeaveTimeout) {
      clearTimeout(this._hoverLeaveTimeout);
      this._hoverLeaveTimeout = null;
    }
    if (this.mainDetailsToggle && !this.mainDetailsToggle.hasAttribute('open')) {
      this.mainDetailsToggle.setAttribute('open', '');
      const summary = this.mainDetailsToggle.querySelector('summary');
      if (summary) summary.setAttribute('aria-expanded', 'true');
    }
  }

  _onMouseLeave() {
    this._mouseInside = false;
    this._hoverLeaveTimeout = setTimeout(() => {
      this.close();
      this._hoverLeaveTimeout = null;
    }, 150);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this._mouseInside) return;
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
